// @see: https://usehooks.com/usemediaquery

export enum MediaQuery {
  IS_LANDSCAPE_MOBILE = 'only screen and (max-height: 575.98px) and (orientation: landscape)',
}
